import { WithStatusU as imported420_WithStatusU, WithModInfo as imported238_WithModInfo, WithModInfoC as imported241_WithModInfoC, WithStatusCU as imported835_WithStatusCU, WithModInfo as imported242_WithModInfo, withModInfoC as imported240_withModInfoC, WithStatusU as imported425_WithStatusU, WithModInfo as imported239_WithModInfo, WithModInfo as imported240_WithModInfo, WithStatusU as imported417_WithStatusU, WithStatusCU as imported831_WithStatusCU, WithStatusU as imported415_WithStatusU, WithStatusCU as imported828_WithStatusCU, WithModInfoC as imported242_WithModInfoC, WithModInfo as imported237_WithModInfo, WithStatusCU as imported836_WithStatusCU, WithModInfo as imported241_WithModInfo, WithStatusCU as imported838_WithStatusCU, WithModInfoC as imported243_WithModInfoC, WithStatusCU as imported846_WithStatusCU, WithStatusCU as imported851_WithStatusCU, WithIdC as imported290_WithIdC, WithStatusU as imported414_WithStatusU, WithStatusCU as imported849_WithStatusCU, WithModInfoC as imported240_WithModInfoC, withModInfoC as imported237_withModInfoC, withModInfoC as imported241_withModInfoC, WithStatusCU as imported829_WithStatusCU, WithStatusCU as imported830_WithStatusCU, WithStatusCU as imported837_WithStatusCU, WithStatusCU as imported844_WithStatusCU, WithModInfo as imported243_WithModInfo, WithStatusCU as imported841_WithStatusCU, WithStatusU as imported424_WithStatusU, WithStatusU as imported423_WithStatusU, WithStatusCU as imported833_WithStatusCU, WithModInfoC as imported239_WithModInfoC, withModInfoC as imported239_withModInfoC, withIdC as imported291_withIdC, withModInfoC as imported243_withModInfoC, WithIdC as imported291_WithIdC, WithModInfoC as imported237_WithModInfoC, WithStatusCU as imported847_WithStatusCU, WithStatusCU as imported834_WithStatusCU, WithStatusCU as imported839_WithStatusCU, withModInfoC as imported242_withModInfoC, withModInfoC as imported238_withModInfoC, WithStatusCU as imported840_WithStatusCU, WithStatusU as imported418_WithStatusU, WithStatusCU as imported843_WithStatusCU, WithStatusU as imported421_WithStatusU, WithStatusCU as imported845_WithStatusCU, WithStatusU as imported419_WithStatusU, WithStatusCU as imported832_WithStatusCU, WithStatusU as imported416_WithStatusU, withIdC as imported290_withIdC, WithStatusCU as imported850_WithStatusCU, WithId as imported291_WithId, WithId as imported290_WithId, WithModInfoC as imported238_WithModInfoC, WithStatusCU as imported842_WithStatusCU, WithStatusCU as imported848_WithStatusCU, WithStatusU as imported422_WithStatusU } from "./threadThrough";
import * as t from "io-ts";
import { Ord as stringOrd } from "fp-ts/lib/string";
import { LocalDateC } from "../../codecs/localDate";
import { taggedContentC as imported228_taggedContentC, TaggedContentC as imported222_TaggedContentC, taggedContentC as imported231_taggedContentC, TaggedContent as imported228_TaggedContent, TaggedContent as imported223_TaggedContent, TaggedContent as imported224_TaggedContent, TaggedContent as imported230_TaggedContent, taggedContentC as imported221_taggedContentC, taggedContentC as imported226_taggedContentC, taggedContentC as imported229_taggedContentC, TaggedContent as imported226_TaggedContent, taggedContentC as imported222_taggedContentC, taggedContentC as imported227_taggedContentC, TaggedContentC as imported228_TaggedContentC, TaggedContentC as imported221_TaggedContentC, TaggedContentC as imported231_TaggedContentC, taggedContentC as imported230_taggedContentC, taggedContentC as imported220_taggedContentC, TaggedContentC as imported224_TaggedContentC, TaggedContent as imported225_TaggedContent, TaggedContentC as imported223_TaggedContentC, TaggedContentC as imported226_TaggedContentC, TaggedContentC as imported225_TaggedContentC, taggedContentC as imported225_taggedContentC, TaggedContentC as imported227_TaggedContentC, TaggedContentC as imported230_TaggedContentC, TaggedContent as imported222_TaggedContent, TaggedContentC as imported229_TaggedContentC, TaggedContent as imported231_TaggedContent, TaggedContent as imported229_TaggedContent, taggedContentC as imported223_taggedContentC, taggedContentC as imported224_taggedContentC, TaggedContentC as imported220_TaggedContentC, TaggedContent as imported220_TaggedContent, TaggedContent as imported227_TaggedContent, TaggedContent as imported221_TaggedContent } from "./taggedContent";
import * as O from "fp-ts/lib/Option";
import { pipe } from "fp-ts/lib/function";
import * as Ord from "fp-ts/lib/Ord";
import { LocalDate } from "@js-joda/core";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";
import { EventC as imported22_EventC, Event as imported21_Event, Event as imported22_Event, eventC as imported20_eventC, eventC as imported21_eventC, EventC as imported21_EventC } from "./event";
import { PageCU as imported14_PageCU, PageCU as imported13_PageCU, PageCU as imported15_PageCU, PageU as imported6_PageU, PageCU as imported12_PageCU, PageU as imported7_PageU } from "../domaintables/pages";
import { RoadShow as imported23_RoadShow, RoadShow as imported24_RoadShow, roadShowC as imported22_roadShowC, RoadShowC as imported24_RoadShowC, RoadShowC as imported23_RoadShowC, roadShowC as imported23_roadShowC } from "./roadshow";
import { projectC as imported36_projectC, projectC as imported37_projectC, ProjectC as imported43_ProjectC, ProjectC as imported44_ProjectC, Project as imported43_Project, Project as imported44_Project } from "./project";
import * as E from "fp-ts/lib/Either";
import { IssuerNews as imported27_IssuerNews, issuerNewsC as imported27_issuerNewsC, IssuerNewsC as imported27_IssuerNewsC, issuerNewsC as imported26_issuerNewsC, IssuerNewsC as imported26_IssuerNewsC, IssuerNews as imported26_IssuerNews } from "./issuerNewsBase";
import { documentWithCategoryC as imported22_documentWithCategoryC, DocumentWithCategoryC as imported23_DocumentWithCategoryC, DocumentWithCategoryC as imported22_DocumentWithCategoryC, DocumentWithCategory as imported23_DocumentWithCategory, documentWithCategoryC as imported23_documentWithCategoryC, DocumentWithCategory as imported22_DocumentWithCategory } from "./document";
import { bondOfferingC as imported37_bondOfferingC, BondOfferingC as imported36_BondOfferingC, BondOfferingC as imported37_BondOfferingC, BondOffering as imported37_BondOffering, BondOffering as imported36_BondOffering, bondOfferingC as imported36_bondOfferingC } from "./bondOfferingBase";
import { RfpC as imported72_RfpC, Rfp as imported72_Rfp, Rfp as imported71_Rfp, RfpC as imported71_RfpC, rfpC as imported69_rfpC, rfpC as imported68_rfpC } from "./rfpBase";

export type FeaturedBondC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedBond`>,
  bond: imported829_WithStatusCU<imported237_WithModInfoC<imported220_TaggedContentC<imported36_BondOfferingC>>>
}>;
export type FeaturedBond = {
  _tag: `FeaturedBond`,
  bond: imported414_WithStatusU<imported237_WithModInfo<imported220_TaggedContent<imported36_BondOffering>>>
};
export const featuredBondC: FeaturedBondC = t.type({
  _tag: t.literal(`FeaturedBond`),
  bond: imported828_WithStatusCU(imported237_withModInfoC(imported220_taggedContentC(imported36_bondOfferingC)))
}) satisfies t.Type<FeaturedBond, unknown>;


export const rfp = {
  _tag: `Rfp`,
  id: 8
} as const;

export type RfpTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Rfp`>
}>;
export const rfpTaggedC: RfpTaggedC = t.type({
  _tag: t.literal(`Rfp`)
});
export type RfpTagged = t.TypeOf<RfpTaggedC>;
export type Rfp = RfpTagged & typeof rfp;
export type RfpC = t.Type<Rfp, RfpTagged>;
export const rfpC: RfpC = pipe(rfpTaggedC, c => new t.Type<Rfp, RfpTagged>(
  `Rfp`,
  (u: unknown): u is Rfp => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Rfp> => pipe(c.decode(u), E.map(x => ({ ...x, ...rfp }))),
  (x: Rfp): RfpTagged => ({ ...x, _tag: `Rfp`}),
)) satisfies t.Type<Rfp, unknown>;


export type FeaturedRfpC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedRfp`>,
  rfp: imported831_WithStatusCU<imported238_WithModInfoC<imported221_TaggedContentC<imported71_RfpC>>>
}>;
export type FeaturedRfp = {
  _tag: `FeaturedRfp`,
  rfp: imported415_WithStatusU<imported238_WithModInfo<imported221_TaggedContent<imported71_Rfp>>>
};
export const featuredRfpC: FeaturedRfpC = t.type({
  _tag: t.literal(`FeaturedRfp`),
  rfp: imported830_WithStatusCU(imported238_withModInfoC(imported221_taggedContentC(imported68_rfpC)))
}) satisfies t.Type<FeaturedRfp, unknown>;


export const news = {
  _tag: `News`,
  id: 3
} as const;

export type NewsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`News`>
}>;
export const newsTaggedC: NewsTaggedC = t.type({
  _tag: t.literal(`News`)
});
export type NewsTagged = t.TypeOf<NewsTaggedC>;
export type News = NewsTagged & typeof news;
export type NewsC = t.Type<News, NewsTagged>;
export const newsC: NewsC = pipe(newsTaggedC, c => new t.Type<News, NewsTagged>(
  `News`,
  (u: unknown): u is News => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, News> => pipe(c.decode(u), E.map(x => ({ ...x, ...news }))),
  (x: News): NewsTagged => ({ ...x, _tag: `News`}),
)) satisfies t.Type<News, unknown>;


export type FeaturedNewsC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedNews`>,
  news: imported833_WithStatusCU<imported239_WithModInfoC<imported222_TaggedContentC<imported26_IssuerNewsC>>>
}>;
export type FeaturedNews = {
  _tag: `FeaturedNews`,
  news: imported416_WithStatusU<imported239_WithModInfo<imported222_TaggedContent<imported26_IssuerNews>>>
};
export const featuredNewsC: FeaturedNewsC = t.type({
  _tag: t.literal(`FeaturedNews`),
  news: imported832_WithStatusCU(imported239_withModInfoC(imported222_taggedContentC(imported26_issuerNewsC)))
}) satisfies t.Type<FeaturedNews, unknown>;


export const event = {
  _tag: `Event`,
  id: 2
} as const;

export type EventTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Event`>
}>;
export const eventTaggedC: EventTaggedC = t.type({
  _tag: t.literal(`Event`)
});
export type EventTagged = t.TypeOf<EventTaggedC>;
export type Event = EventTagged & typeof event;
export type EventC = t.Type<Event, EventTagged>;
export const eventC: EventC = pipe(eventTaggedC, c => new t.Type<Event, EventTagged>(
  `Event`,
  (u: unknown): u is Event => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Event> => pipe(c.decode(u), E.map(x => ({ ...x, ...event }))),
  (x: Event): EventTagged => ({ ...x, _tag: `Event`}),
)) satisfies t.Type<Event, unknown>;


export type FeaturedEventC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedEvent`>,
  event: imported835_WithStatusCU<imported240_WithModInfoC<imported21_EventC>>
}>;
export type FeaturedEvent = {
  _tag: `FeaturedEvent`,
  event: imported417_WithStatusU<imported240_WithModInfo<imported21_Event>>
};
export const featuredEventC: FeaturedEventC = t.type({
  _tag: t.literal(`FeaturedEvent`),
  event: imported834_WithStatusCU(imported240_withModInfoC(imported20_eventC))
}) satisfies t.Type<FeaturedEvent, unknown>;


export const document = {
  _tag: `Document`,
  id: 1
} as const;

export type DocumentTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Document`>
}>;
export const documentTaggedC: DocumentTaggedC = t.type({
  _tag: t.literal(`Document`)
});
export type DocumentTagged = t.TypeOf<DocumentTaggedC>;
export type Document = DocumentTagged & typeof document;
export type DocumentC = t.Type<Document, DocumentTagged>;
export const documentC: DocumentC = pipe(documentTaggedC, c => new t.Type<Document, DocumentTagged>(
  `Document`,
  (u: unknown): u is Document => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Document> => pipe(c.decode(u), E.map(x => ({ ...x, ...document }))),
  (x: Document): DocumentTagged => ({ ...x, _tag: `Document`}),
)) satisfies t.Type<Document, unknown>;


export type FeaturedDocumentC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedDocument`>,
  document: imported837_WithStatusCU<imported241_WithModInfoC<imported223_TaggedContentC<imported22_DocumentWithCategoryC>>>
}>;
export type FeaturedDocument = {
  _tag: `FeaturedDocument`,
  document: imported418_WithStatusU<imported241_WithModInfo<imported223_TaggedContent<imported22_DocumentWithCategory>>>
};
export const featuredDocumentC: FeaturedDocumentC = t.type({
  _tag: t.literal(`FeaturedDocument`),
  document: imported836_WithStatusCU(imported241_withModInfoC(imported223_taggedContentC(imported22_documentWithCategoryC)))
}) satisfies t.Type<FeaturedDocument, unknown>;


export const project = {
  _tag: `Project`,
  id: 6
} as const;

export type ProjectTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Project`>
}>;
export const projectTaggedC: ProjectTaggedC = t.type({
  _tag: t.literal(`Project`)
});
export type ProjectTagged = t.TypeOf<ProjectTaggedC>;
export type Project = ProjectTagged & typeof project;
export type ProjectC = t.Type<Project, ProjectTagged>;
export const projectC: ProjectC = pipe(projectTaggedC, c => new t.Type<Project, ProjectTagged>(
  `Project`,
  (u: unknown): u is Project => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Project> => pipe(c.decode(u), E.map(x => ({ ...x, ...project }))),
  (x: Project): ProjectTagged => ({ ...x, _tag: `Project`}),
)) satisfies t.Type<Project, unknown>;


export type FeaturedProjectC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedProject`>,
  project: imported839_WithStatusCU<imported242_WithModInfoC<imported224_TaggedContentC<imported43_ProjectC>>>
}>;
export type FeaturedProject = {
  _tag: `FeaturedProject`,
  project: imported419_WithStatusU<imported242_WithModInfo<imported224_TaggedContent<imported43_Project>>>
};
export const featuredProjectC: FeaturedProjectC = t.type({
  _tag: t.literal(`FeaturedProject`),
  project: imported838_WithStatusCU(imported242_withModInfoC(imported224_taggedContentC(imported36_projectC)))
}) satisfies t.Type<FeaturedProject, unknown>;


export const roadShow = {
  _tag: `RoadShow`,
  id: 7
} as const;

export type RoadShowTaggedC = t.TypeC<{
  _tag: t.LiteralC<`RoadShow`>
}>;
export const roadShowTaggedC: RoadShowTaggedC = t.type({
  _tag: t.literal(`RoadShow`)
});
export type RoadShowTagged = t.TypeOf<RoadShowTaggedC>;
export type RoadShow = RoadShowTagged & typeof roadShow;
export type RoadShowC = t.Type<RoadShow, RoadShowTagged>;
export const roadShowC: RoadShowC = pipe(roadShowTaggedC, c => new t.Type<RoadShow, RoadShowTagged>(
  `RoadShow`,
  (u: unknown): u is RoadShow => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, RoadShow> => pipe(c.decode(u), E.map(x => ({ ...x, ...roadShow }))),
  (x: RoadShow): RoadShowTagged => ({ ...x, _tag: `RoadShow`}),
)) satisfies t.Type<RoadShow, unknown>;


export type FeaturedRoadshowC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedRoadshow`>,
  roadshow: imported290_WithIdC<imported243_WithModInfoC<imported225_TaggedContentC<imported23_RoadShowC>>>
}>;
export type FeaturedRoadshow = {
  _tag: `FeaturedRoadshow`,
  roadshow: imported290_WithId<imported243_WithModInfo<imported225_TaggedContent<imported23_RoadShow>>>
};
export const featuredRoadshowC: FeaturedRoadshowC = t.type({
  _tag: t.literal(`FeaturedRoadshow`),
  roadshow: imported290_withIdC(imported243_withModInfoC(imported225_taggedContentC(imported22_roadShowC)))
}) satisfies t.Type<FeaturedRoadshow, unknown>;


export const page = {
  _tag: `Page`,
  id: 5
} as const;

export type PageTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Page`>
}>;
export const pageTaggedC: PageTaggedC = t.type({
  _tag: t.literal(`Page`)
});
export type PageTagged = t.TypeOf<PageTaggedC>;
export type Page = PageTagged & typeof page;
export type PageC = t.Type<Page, PageTagged>;
export const pageC: PageC = pipe(pageTaggedC, c => new t.Type<Page, PageTagged>(
  `Page`,
  (u: unknown): u is Page => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Page> => pipe(c.decode(u), E.map(x => ({ ...x, ...page }))),
  (x: Page): PageTagged => ({ ...x, _tag: `Page`}),
)) satisfies t.Type<Page, unknown>;


export type FeaturedPageC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedPage`>,
  page: imported13_PageCU,
  header: t.StringC
}>;
export type FeaturedPage = {
  _tag: `FeaturedPage`,
  page: imported6_PageU,
  header: string
};
export const featuredPageC: FeaturedPageC = t.type({
  _tag: t.literal(`FeaturedPage`),
  page: imported12_PageCU,
  header: t.string
}) satisfies t.Type<FeaturedPage, unknown>;


export const allFeaturedItemC = [featuredBondC, featuredRfpC, featuredNewsC, featuredEventC, featuredDocumentC, featuredProjectC, featuredRoadshowC, featuredPageC] as const;
export const allFeaturedItemNames = [`FeaturedBond`, `FeaturedRfp`, `FeaturedNews`, `FeaturedEvent`, `FeaturedDocument`, `FeaturedProject`, `FeaturedRoadshow`, `FeaturedPage`] as const;
export type FeaturedItemName = (typeof allFeaturedItemNames)[number];

export type FeaturedItemCU = t.UnionC<[FeaturedBondC, FeaturedRfpC, FeaturedNewsC, FeaturedEventC, FeaturedDocumentC, FeaturedProjectC, FeaturedRoadshowC, FeaturedPageC]>;
export type FeaturedItemU = FeaturedBond | FeaturedRfp | FeaturedNews | FeaturedEvent | FeaturedDocument | FeaturedProject | FeaturedRoadshow | FeaturedPage;
export const FeaturedItemCU: FeaturedItemCU = t.union([featuredBondC, featuredRfpC, featuredNewsC, featuredEventC, featuredDocumentC, featuredProjectC, featuredRoadshowC, featuredPageC]) satisfies t.Type<FeaturedItemU, unknown>;

export type FeaturedItemMap<A> = { [K in FeaturedItemName]: A };


export type FeaturedItemWithMetaC = t.TypeC<{
  item: FeaturedItemCU,
  displayUntil: OptionFromNullableC<LocalDateC>,
  sortOrder: t.NumberC
}>;
export type FeaturedItemWithMeta = {
  item: FeaturedItemU,
  displayUntil: O.Option<LocalDate>,
  sortOrder: number
};
export const featuredItemWithMetaC: FeaturedItemWithMetaC = t.type({
  item: FeaturedItemCU,
  displayUntil: optionFromNullable(LocalDateC),
  sortOrder: t.number
}) satisfies t.Type<FeaturedItemWithMeta, unknown>;


export type FeaturedItemsAvailableC = t.TypeC<{
  bonds: t.ReadonlyArrayC<imported846_WithStatusCU<imported226_TaggedContentC<imported37_BondOfferingC>>>,
  rfps: t.ReadonlyArrayC<imported847_WithStatusCU<imported227_TaggedContentC<imported72_RfpC>>>,
  news: t.ReadonlyArrayC<imported848_WithStatusCU<imported228_TaggedContentC<imported27_IssuerNewsC>>>,
  events: t.ReadonlyArrayC<imported849_WithStatusCU<imported22_EventC>>,
  documents: t.ReadonlyArrayC<imported850_WithStatusCU<imported229_TaggedContentC<imported23_DocumentWithCategoryC>>>,
  projects: t.ReadonlyArrayC<imported851_WithStatusCU<imported230_TaggedContentC<imported44_ProjectC>>>,
  roadshows: t.ReadonlyArrayC<imported291_WithIdC<imported231_TaggedContentC<imported24_RoadShowC>>>,
  pages: t.ReadonlyArrayC<imported15_PageCU>
}>;
export type FeaturedItemsAvailable = {
  bonds: ReadonlyArray<imported420_WithStatusU<imported226_TaggedContent<imported37_BondOffering>>>,
  rfps: ReadonlyArray<imported421_WithStatusU<imported227_TaggedContent<imported72_Rfp>>>,
  news: ReadonlyArray<imported422_WithStatusU<imported228_TaggedContent<imported27_IssuerNews>>>,
  events: ReadonlyArray<imported423_WithStatusU<imported22_Event>>,
  documents: ReadonlyArray<imported424_WithStatusU<imported229_TaggedContent<imported23_DocumentWithCategory>>>,
  projects: ReadonlyArray<imported425_WithStatusU<imported230_TaggedContent<imported44_Project>>>,
  roadshows: ReadonlyArray<imported291_WithId<imported231_TaggedContent<imported24_RoadShow>>>,
  pages: ReadonlyArray<imported7_PageU>
};
export const featuredItemsAvailableC: FeaturedItemsAvailableC = t.type({
  bonds: t.readonlyArray(imported840_WithStatusCU(imported226_taggedContentC(imported37_bondOfferingC))),
  rfps: t.readonlyArray(imported841_WithStatusCU(imported227_taggedContentC(imported69_rfpC))),
  news: t.readonlyArray(imported842_WithStatusCU(imported228_taggedContentC(imported27_issuerNewsC))),
  events: t.readonlyArray(imported843_WithStatusCU(imported21_eventC)),
  documents: t.readonlyArray(imported844_WithStatusCU(imported229_taggedContentC(imported23_documentWithCategoryC))),
  projects: t.readonlyArray(imported845_WithStatusCU(imported230_taggedContentC(imported37_projectC))),
  roadshows: t.readonlyArray(imported291_withIdC(imported231_taggedContentC(imported23_roadShowC))),
  pages: t.readonlyArray(imported14_PageCU)
}) satisfies t.Type<FeaturedItemsAvailable, unknown>;


export type FeaturedItemPostBodyC = t.TypeC<{
  id: t.NumberC,
  itemId: t.NumberC,
  itemTypeId: t.NumberC,
  header: OptionFromNullableC<t.StringC>,
  displayUntil: OptionFromNullableC<LocalDateC>,
  sortOrder: t.NumberC
}>;
export type FeaturedItemPostBody = {
  id: number,
  itemId: number,
  itemTypeId: number,
  header: O.Option<string>,
  displayUntil: O.Option<LocalDate>,
  sortOrder: number
};
export const featuredItemPostBodyC: FeaturedItemPostBodyC = t.type({
  id: t.number,
  itemId: t.number,
  itemTypeId: t.number,
  header: optionFromNullable(t.string),
  displayUntil: optionFromNullable(LocalDateC),
  sortOrder: t.number
}) satisfies t.Type<FeaturedItemPostBody, unknown>;


export const offering = {
  _tag: `Offering`,
  id: 4
} as const;

export type OfferingTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Offering`>
}>;
export const offeringTaggedC: OfferingTaggedC = t.type({
  _tag: t.literal(`Offering`)
});
export type OfferingTagged = t.TypeOf<OfferingTaggedC>;
export type Offering = OfferingTagged & typeof offering;
export type OfferingC = t.Type<Offering, OfferingTagged>;
export const offeringC: OfferingC = pipe(offeringTaggedC, c => new t.Type<Offering, OfferingTagged>(
  `Offering`,
  (u: unknown): u is Offering => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Offering> => pipe(c.decode(u), E.map(x => ({ ...x, ...offering }))),
  (x: Offering): OfferingTagged => ({ ...x, _tag: `Offering`}),
)) satisfies t.Type<Offering, unknown>;


export const allFeaturedItemTypeC = [documentC, eventC, newsC, offeringC, pageC, projectC, roadShowC, rfpC] as const;
export const allFeaturedItemTypeNames = [`Document`, `Event`, `News`, `Offering`, `Page`, `Project`, `RoadShow`, `Rfp`] as const;
export type FeaturedItemTypeName = (typeof allFeaturedItemTypeNames)[number];

export type FeaturedItemTypeCU = t.UnionC<[DocumentC, EventC, NewsC, OfferingC, PageC, ProjectC, RoadShowC, RfpC]>;
export type FeaturedItemTypeU = Document | Event | News | Offering | Page | Project | RoadShow | Rfp;
export const FeaturedItemTypeCU: FeaturedItemTypeCU = t.union([documentC, eventC, newsC, offeringC, pageC, projectC, roadShowC, rfpC]) satisfies t.Type<FeaturedItemTypeU, unknown>;

export const featuredItemTypeOrd: Ord.Ord<FeaturedItemTypeU> = pipe(stringOrd, Ord.contramap(x => x._tag));
export const allFeaturedItemType = [document, event, news, offering, page, project, roadShow, rfp] as const;
export type FeaturedItemTypeMap<A> = { [K in FeaturedItemTypeName]: A };


